<div class="recurrence-modal">
  <form nz-form [formGroup]="form">
    <div class="row" *ngIf="nzModalData.schedulerLabel">
      <label class="field-label">Scheduler Name</label>
      <input nz-input formControlName="schedulerLabel" placeholder="Enter scheduler name" class="scheduler-input">
    </div>
    
    <div class="row">
      <label class="field-label">Start Date <span class="red_color">*</span></label>
      <nz-date-picker #startDateRef formControlName="startDate" [nzDisabledDate]="disableStartDate" [nzAllowClear]="true" [nzStatus]="(submitted || form.get('startDate')?.touched) && form.get('startDate')?.invalid ? 'error' : ''"></nz-date-picker>
    </div>

    <div class="row">
      <label class="field-label">Start Time <span class="red_color">*</span></label>
      <nz-time-picker #startTimeRef formControlName="startTime" [nzFormat]="'HH:mm'" [nzUse12Hours]="false" [nzAllowEmpty]="true" [nzStatus]="(submitted || form.get('startTime')?.touched) && form.get('startTime')?.invalid ? 'error' : ''"></nz-time-picker>
    </div>

    <div class="row repeat-row">
      <label class="field-label">Frequency <span class="red_color">*</span></label>
      <nz-select #unitSelectRef class="unit-select" formControlName="unit" [nzAllowClear]="true" [nzStatus]="(submitted || form.get('unit')?.touched) && form.get('unit')?.invalid ? 'error' : ''">
        <nz-option *ngFor="let opt of unitOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
      </nz-select>
    </div>

    <div class="row weekdays" *ngIf="form.value.unit === 'day' || form.value.unit === 'week'">
      <button
        class="weekday-chip"
        nz-button
        *ngFor="let w of weekdayLabels"
        nzSize="small"
        [nzType]="isWeekdaySelected(w.value) ? 'primary' : 'default'"
        (click)="$event.preventDefault(); toggleWeekday(w.value)"
      >
        {{ w.label }}
      </button>
    </div>



    <div class="row summary">
      <span>{{ summaryText }}</span>
    </div>

    <div class="row end-row">
      <label class="field-label">End date</label>
      <nz-date-picker formControlName="endDate" [nzDisabledDate]="disableEndDate"></nz-date-picker>
    </div>
  </form>

  <div class="footer">
    <button nz-button nzType="primary" class="save_btn_style" (click)="save()">Save</button>
    <button nz-button nzType="default" class="cancel_btn_style" (click)="cancel()">Cancel</button>
  </div>
</div>


